var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuInstrumentMappingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 8C0.666016 7.63181 0.964492 7.33333 1.33268 7.33333H14.666C15.0342 7.33333 15.3327 7.63181 15.3327 8C15.3327 8.36819 15.0342 8.66667 14.666 8.66667H1.33268C0.964492 8.66667 0.666016 8.36819 0.666016 8Z",
    fill: "#7E716D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82601 2L11.1727 2C11.5448 2.0002 11.9098 2.10419 12.226 2.30028C12.5419 2.4962 12.797 2.77629 12.9626 3.10912C12.9627 3.10941 12.9629 3.10971 12.963 3.11L15.2621 7.70151C15.3085 7.79417 15.3327 7.89637 15.3327 8V12C15.3327 12.5304 15.122 13.0391 14.7469 13.4142C14.3718 13.7893 13.8631 14 13.3327 14H2.66602C2.13558 14 1.62687 13.7893 1.2518 13.4142C0.876729 13.0391 0.666016 12.5304 0.666016 12V8C0.666016 7.89637 0.690173 7.79417 0.736571 7.70151L3.03566 3.11C3.03582 3.10968 3.03598 3.10935 3.03615 3.10903C3.20174 2.77624 3.4568 2.49618 3.77271 2.30028C4.08893 2.10419 4.45393 2.0002 4.82601 2ZM3.63268 3.40667L4.22879 3.70516L1.99935 8.15758V12C1.99935 12.1768 2.06959 12.3464 2.19461 12.4714C2.31964 12.5964 2.4892 12.6667 2.66602 12.6667H13.3327C13.5095 12.6667 13.6791 12.5964 13.8041 12.4714C13.9291 12.3464 13.9993 12.1768 13.9993 12V8.15758L11.7699 3.70516L11.769 3.70333C11.7138 3.59226 11.6287 3.49879 11.5233 3.43343C11.4179 3.36809 11.2964 3.33342 11.1725 3.33333H4.82624C4.70226 3.33342 4.58075 3.36808 4.47538 3.43343C4.36998 3.49879 4.28489 3.59226 4.2297 3.70333L3.63268 3.40667Z",
    fill: "#7E716D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuInstrumentMappingIcon);
export default __webpack_public_path__ + "static/media/menu-instrument-mapping-icon.21b9a8c80b95a5bea3d384b1ab874581.svg";
export { ForwardRef as ReactComponent };